export default __webpack_public_path__ + "static/media/compare-ar.cce7f752.svg";